module.exports = __webpack_public_path__ + "img/construction_banner.3044951d.webp";